import { createIdentifier } from '@wix/thunderbolt-ioc'

export interface IDomSelectors {
	getByCompId(compId: string, doc?: Document): HTMLElement | null
	getClosestByCompId(element: Element, compId: string): Element | null
	querySelector(selector: string, doc?: Document): Element | null
	querySelectorAll(selector: string, doc?: Document): Element[]
	getElementCompId(element: Element): string
}

export const DomSelectorsSymbol = createIdentifier<IDomSelectors>(Symbol('DomSelectors'))
